import clsx from 'clsx'
import React from 'react'
import {useTranslation} from 'react-i18next'

import './ItemRow.scss'
const ItemRow = ({data, checked, onChange, style = {}, showAdvOpt, onClickAdvOpt, disabled}) => {
  const {t} = useTranslation()
  return (
    <div
      className={clsx('ds-menu-item ds-flex-no-shrink', {'ds-disabled': !!disabled})}
      style={style}
    >
      <div className="ds-t070r ds-text-ellipsis ds-flex-no-spill" title={data.name}>
        {data.name}
      </div>
      {showAdvOpt && checked && (
        <button className="ds-btn-link-small" onClick={onClickAdvOpt}>
          {t('calendar.view.add.display-fields.btn-adv-option')}
        </button>
      )}

      <div class="show_reservation">
        <label class="reservation-tooltip">
          <input
            type="checkbox"
            id="reservation_toggle"
            className="ds-toggle-basic-sm"
            checked={checked}
            onClick={e => onChange(e, !checked)}
          />
          <span class="slider round"></span>
          <span class="right_icon"></span>
          <span class="cross_icon"></span>
        </label>
      </div>
    </div>
  )
}

export default ItemRow
